import React from 'react';
import Header from '../components/Header';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import '../App.css';

const ContactPage = () => {
  return (
    <div className="App">
      <Header />
      <Contact />
      <Footer />
    </div>
  );
};

export default ContactPage;

